<template lang="pug">
  div
    h1.seo-only 佑昇生殖中心｜試管嬰兒、不孕症治療與凍卵諮詢
    Carousel
    MainTitle
    KnowUSoon(:is-index="true")
    Service(isIndex)
    OurTeam
    ContactUs(:is-index="true")
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import MainTitle from "@/components/MainTitle.vue";
import KnowUSoon from "@/views/KnowUSoon.vue";
import Service from "@/views/Service.vue";
import OurTeam from "@/components/OurTeam.vue";
import ContactUs from "@/views/ContactUs.vue";

export default {
  name: "Index",

  components: {
    Carousel,
    MainTitle,
    KnowUSoon,
    Service,
    OurTeam,
    ContactUs,
  },
};
</script>
